import React, { useState, useEffect } from "react";
import { ImCross } from "react-icons/im";
import { useNavigate } from 'react-router-dom';
import { IoMdArrowBack } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import Pagination from "./Pagenation";
import { getAllConfig, deleteConfig, createConfig, updateConfig } from "../api/configapi";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";

const Table = () => {
  const [menuDetailOpen, setMenuDetailOpen] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [fields, setFields] = useState([]);
  const [name, setName] = useState("");
  const [fieldInput, setFieldInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const navigate = useNavigate();
  const [editId, setEditId] = useState(null);

  // Safe flattening
  const flattened = Array.isArray(dataList)
    ? dataList.flatMap((entry) =>
        entry.fields?.map((field, index) => ({
          name: entry.name,
          field,
          fieldCount: entry.fields.length,
          /* isFirstField: index === 0, */
        }))
      )
    : [];

  const totalPages = Math.ceil(flattened.length / itemsPerPage);
  const indexOfFirst = (currentPage - 1) * itemsPerPage;
  const indexOfLast = indexOfFirst + itemsPerPage;
  const currentData = flattened.slice(indexOfFirst, indexOfLast);

  const handleAddField = () => {
    if (fieldInput.trim() === "") return;
    setFields([...fields, fieldInput.trim()]);
    setFieldInput("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddField();
    }
  };

  const handleFieldChange = (index, value) => {
    const updated = [...fields];
    updated[index] = value;
    setFields(updated);
  };

  const handleRemoveField = (index) => {
    deleteConfig().then((res) => console.log(res));
    setFields(fields.filter((_, i) => i !== index));
  };


const handleSave = async () => {
  const trimmedFields = fields?.filter((f) => f.trim() !== "");
  if (!name.trim() || trimmedFields?.length === 0) {
    toast.error("Please fill all fields");
    return;
  }

  const newEntry = {
    name: name.trim(),
    feilds: trimmedFields, 
  };

  if (editId) {
     try {
    await updateConfig(editId,newEntry)
    const updated = dataList.map((d) => (d.id === editId ? { ...d, ...newEntry } : d));
    setDataList(updated);
    setEditId(null);
    toast.success("Field updated successfully");
   setName("");
    setFields([]);
    setFieldInput("");
    setMenuDetailOpen(false);}
   catch (err) {
     
      console.error("Create Config Error:", err.response?.data || err);
    }
  } else {
   
    try {
      const saved = await createConfig(newEntry);
      toast.success("Field saved successfully");

      const updatedList = await getAllConfig();
      setDataList(Array.isArray(updatedList?.data) ? updatedList.data : []);

      setName("");
      setFields([]);
      setFieldInput("");
      setMenuDetailOpen(false);
    } catch (err) {
      toast.error("Failed to save. Please try again.");
      console.error("Create Config Error:", err.response?.data || err);
    }
  }
};



  const handleEdit = (id) => {
  const editItem = dataList.find((i) => i._id === id);
 if (editItem) {
    setName(editItem.name);
    setFields(editItem.feilds || []); 
    setEditId(id);
    setMenuDetailOpen(true);
  } else {
    toast.error("Item not found for editing.");
  }
};



 const handleDelete = (id) => {
    deleteConfig(id)
    .then((res) => {
      const updated = dataList.filter((item) => item.id !== id);
      setDataList(updated);
      toast.success("Deleted successfully");
    })
    .catch((err) => {
      console.error("Delete failed:", err);
      toast.error("Failed to delete");
    });
};



  useEffect(() =>{
    getAllConfig()
    .then((res) =>setDataList(res.data)
    ).catch(err=>console.log(err))
  },[])

  console.log(dataList)

  return (
    <div className="px-5 md:px-10 mt-[10%]">
      <h2 className="font-bold text-xl text-primary mt-4">நிகழ்வு அட்டவணை</h2>

      <div className="flex justify-between mt-3">
        <button onClick={() => navigate(-1)}>
          <IoMdArrowBack fontSize={30} className="text-black hover:text-red-600 font-bold" />
        </button>
        <button
          className="bg-primary text-white px-4 py-2 rounded-md text-sm"
          onClick={() => setMenuDetailOpen(true)}
        >
         சேர்
        </button>
      </div>

      <div className="w-full overflow-x-auto mt-5">
        <table className="min-w-[700px] w-full border rounded-xl overflow-hidden shadow-sm">
          <thead>
            <tr className="bg-[#f7f7f7] text-nowrap">
              {["எஸ்.எண்", "பெயர்", "துறை","செயல்"].map((col, i) => (
                <th
                  key={i}
                  className="text-sm font-semibold bg-primary text-white border-b px-5 py-4 text-start"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white text-gray-700 text-sm">
            {dataList?.map((item, i) => (
              <tr key={i}>
                <td className="px-5 py-4 border-b">{i+1}</td>
                <td className="px-5 py-4 border-b">{item?.name}</td>
                <td className="px-5 py-4 border-b">{item?.feilds?.join(',')}</td>
                <td>
                  <button>
                   < CiEdit  onClick={() => handleEdit(item._id)}/>
                  </button>
                  <button>
                    <MdDeleteOutline onClick={() => handleDelete(item._id)}/>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}

      {menuDetailOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
          <div className="w-96 p-6 rounded-md h-full shadow-lg bg-white">
            <div className="flex mt-5 justify-between">
              <h4 className="text-primary font-semibold text-lg">நிகழ்வைச் சேர்க்கவும்</h4>
              <button onClick={() => setMenuDetailOpen(false)}>
                <ImCross size={18} />
              </button>
            </div>

            <div className="mt-5">
              <label className="block mb-1 text-sm">பெயர்</label>
              <input
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="px-4 py-2 rounded-md border border-gray-300 w-full text-sm"
              />
            </div>

            <div className="mt-5">
              <div className="mb-4">
                <label className="block mb-1 text-sm">துறை</label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Enter field"
                    className="w-full rounded-md px-4 py-2 pr-10 border border-gray-300 text-sm"
                    value={fieldInput}
                    onChange={(e) => setFieldInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <FaPlus
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer text-sm"
                    onClick={handleAddField}
                  />
                </div>
              </div>

              {fields?.map((field, index) => (
                <div key={index} className="flex items-center gap-2 mb-2">
                  <input
                    type="text"
                    value={field}
                    onChange={(e) => handleFieldChange(index, e.target.value)}
                    className="px-3 py-2 rounded-md border border-gray-300 w-full"
                  />
                  <button onClick={() => handleRemoveField(index)}>
                    <ImCross size={16} className="text-red-500" />
                  </button>
                </div>
              ))}
            </div>

            <div className="mt-6">
              <button
                className="w-full bg-primary text-white px-4 py-2 rounded-md text-sm"
                onClick={handleSave}
              >
               நுழைவை சேமிக்கவும்
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Table;
